export default {
  name: "EventPrices",
  data: () => ({
    editorUrl: "https://cdn.eberl-online.cloud/ckeditor5/ckeditor5.js",
    payments: [
      "Bar",
      "EC-Karte",
      "Visa",
      "Mastercard",
      "American Express",
      "Online"
    ],
    discount: [
      { value: "withFee", title: "Mit Eintritt" },
      { value: "free_access", title: "Frei" },
      { value: "guest_card", title: "Frei mit Gästekarte" },
      { value: "discountGuestCard", title: "Vergünstigt mit Gästekarte" }
    ],
    mainPeacock: "#00636C"
  }),
  props: ["editedEvent", "step", "position", "isOwnedBySubPrincipal"],
  methods: {
    changeToFreeAccess(value) {
      if (!value) this.editedEvent.discount = [];
      // remove free_access its not the only choice
      const index = value.length - 1;
      if (value[0] === "free_access" && value[index] !== "free_access") {
        this.editedEvent.discount.splice(0, 1);
      }
      // if free_access remove others
      value.forEach(item => {
        if (item === "free_access") {
          value = this.editedEvent.discount = ["free_access"];
          this.editedEvent.price_from = "";
          this.editedEvent.payment = [];
          this.editedEvent.advance_booking = false;
          this.editedEvent.box_office = false;
        }
      });
    }
  }
};
